import { LiliButton } from '@lili/lili-frontend-common';
import React from 'react';

interface InviteStepFooterProps {
  onClick: () => void;
  buttonTitle: string;
  disabled?: boolean;
  isLoading: boolean;
}

export const InviteStepFooter = ({ onClick, buttonTitle, isLoading, disabled = false }: InviteStepFooterProps) => (
  <div className='py-[24px] px-[34px] w-full border-t border-t-bw03 flex flex-col items-center bg-surface-primary-bw-00'>
    <div className='w-[375px]'>
      <LiliButton
        id='invite-footer-button'
        title={buttonTitle}
        onClick={onClick}
        disabled={disabled || isLoading}
        isLoading={isLoading}
      />
    </div>
  </div>
);
